import _ from "lodash";
import React, { useRef } from "react";
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

function TypeaheadField(props) {
  const { schema, uiSchema, idPrefix, name, formData, onChange } = props;
  const { title, options } = schema;
  const uiOptions = _.get(uiSchema, 'ui:options');
	const widget = _.get(uiSchema, 'ui:widget', "");

  const ref = useRef();

	if (widget === 'hidden') {
		return null;
	}

  return (
    <React.Fragment>
      <label>{title}</label>
      <div className="form-group">
        {
          <Typeahead
            id={`${idPrefix}_${name}`}
            ref={ref}
            multiple={uiOptions.multiple}
            allowNew={uiOptions.allowNew}
            placeholder={uiOptions.placeholder}
            maxResults={10}
            options={options}
            defaultSelected={formData}
            onChange={(selected) => {
              onChange(selected);
            }}
          />
        }
      </div>
    </React.Fragment>
  )
}

export default TypeaheadField;